// extracted by mini-css-extract-plugin
export default {"image":"DarkstoreSleepModal_image__jVqYa","title":"DarkstoreSleepModal_title__sEKTT","content":"DarkstoreSleepModal_content__FFMdf"};